import { initializeApp } from "firebase/app"
import { getFirestore, onSnapshot, doc } from "firebase/firestore"
import { collection, query, where, getDocs } from "firebase/firestore"

export const firebaseConfig = {
  apiKey: "AIzaSyD_GljHwD1QzcE5q0og915_1pwHstbybvo",
  authDomain: "dead-island-2-eaaaa.firebaseapp.com",
  databaseURL: "https://dead-island-2-eaaaa-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "dead-island-2-eaaaa",
  storageBucket: "dead-island-2-eaaaa.appspot.com",
  messagingSenderId: "922081846047",
  appId: "1:922081846047:web:93fa12d08d944bc32f062a",
  measurementId: "G-YZLK7QXVS4"
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)

import { getAuth } from "firebase/auth"

export const auth = getAuth()
export {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  onAuthStateChanged,
  signOut as signOutAuth
} from "firebase/auth"
import { getDatabase, ref, child, push, update } from "firebase/database";

export const get = async (ref, opt = []) => {
  if (opt && opt.length) {
    const q = query(collection(db, ref), where(opt[0], opt[1], opt[2]))
    return getDocs(q)
  } else {
    const q = query(collection(db, ref))
    return getDocs(q)
  }
}

export const on = (path, id, callback) => {
  return onSnapshot(doc(db, `${path}/${id}`), docRef => {
    return callback ? callback(docRef.data()) : docRef.data()
  })
}


export const write = (_path, data) => {
  const [path, id] = _path.split('/')
  const db = getDatabase();
  const key = id || push(child(ref(db), path)).key;
  const updates = {
    [`/${path}/${key}`]: data
  }
  return update(ref(db), updates);
}
